export default "__VITE_ASSET__CDnS2d6L__"